import { render, staticRenderFns } from "./TheHeaderMaisoku.vue?vue&type=template&id=3b08bc9a&scoped=true&"
import script from "./TheHeaderMaisoku.vue?vue&type=script&lang=js&"
export * from "./TheHeaderMaisoku.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderMaisoku.vue?vue&type=style&index=0&id=3b08bc9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b08bc9a",
  null
  
)

export default component.exports